
import { Guest } from "@/types";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface GuestFormProps {
  guests: Guest[];
  guestName: string;
  skillLevel: string;
  gender: string;
  selectedTimeSlot: string | null;
  onGuestNameChange: (value: string) => void;
  onSkillLevelChange: (value: string) => void;
  onGenderChange: (value: string) => void;
  onAddGuest: () => void;
  onJoin: () => void;
}

export const GuestForm = ({
  guests,
  guestName,
  skillLevel,
  gender,
  selectedTimeSlot,
  onGuestNameChange,
  onSkillLevelChange,
  onGenderChange,
  onAddGuest,
  onJoin,
}: GuestFormProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <h2 className="text-xl font-semibold mb-6">Add Guests (Optional)</h2>
      
      <div className="space-y-4 mb-6">
        <Input
          placeholder="Guest Name"
          value={guestName}
          onChange={(e) => onGuestNameChange(e.target.value)}
        />
        
        <Select value={skillLevel} onValueChange={onSkillLevelChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select skill level" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Beginner">Beginner</SelectItem>
            <SelectItem value="Intermediate">Intermediate</SelectItem>
            <SelectItem value="Advanced">Advanced</SelectItem>
            <SelectItem value="Professional">Professional</SelectItem>
          </SelectContent>
        </Select>

        <Select value={gender} onValueChange={onGenderChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select gender" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Male">Male</SelectItem>
            <SelectItem value="Female">Female</SelectItem>
          </SelectContent>
        </Select>

        <Button
          onClick={onAddGuest}
          className="w-full"
          variant="outline"
          disabled={!guestName || !skillLevel || !gender}
        >
          Add Guest
        </Button>
      </div>

      {guests.length > 0 && (
        <div>
          <h3 className="font-medium mb-3">Added Guests:</h3>
          <div className="space-y-2">
            {guests.map((guest) => (
              <div
                key={guest.id}
                className="p-3 bg-gray-50 rounded-md text-sm"
              >
                <p className="font-medium">{guest.name}</p>
                <p className="text-gray-600">
                  {guest.skillLevel} • {guest.gender}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      <Button 
        className="w-full mt-6 bg-primary hover:bg-primary/90"
        disabled={!selectedTimeSlot}
        onClick={onJoin}
      >
        {guests.length > 0
          ? `I'm Joining with ${guests.length} guest${
              guests.length > 1 ? "s" : ""
            }`
          : "I'm Joining (no guests)"}
      </Button>
    </div>
  );
};
